interface ListedCfdLogo {
  src: string;
  name: string;
  fallback: string;
}

const ISHARES_LOGO: ListedCfdLogo = {
  src: '/asset-logos/ishares.svg', name: 'iShares', fallback: 'iS',
};

const LISTED_CFD_LOGOS: Record<string, ListedCfdLogo> = {
  'IWDA.L': ISHARES_LOGO,
  'EWLD.PA': { src: '/asset-logos/amundi.svg', name: 'Amundi', fallback: 'A' },
  'WSRIA.SW': { src: '/asset-logos/ubs.svg', name: 'UBS', fallback: 'UBS' },
  'CSPX.L': ISHARES_LOGO,
  'NOVO-B.CO': { src: '/asset-logos/novo-nordisk.svg', name: 'Novo Nordisk', fallback: 'NN' },
};

export const getListedCfdLogo = (symbol: string): ListedCfdLogo | undefined =>
  Object.prototype.hasOwnProperty.call(LISTED_CFD_LOGOS, symbol) ? LISTED_CFD_LOGOS[symbol] : undefined;
